export const CHECK_VERIFICATION_START = "CHECK_VERIFICATION_START";
export const CHECK_VERIFICATION_SUCCESS = "CHECK_VERIFICATION_SUCCESS";
export const CHECK_VERIFICATION_ERROR = "CHECK_VERIFICATION_ERROR";

export const checkVerificationStatus = (reference) => async (dispatch) => {
  dispatch({ type: CHECK_VERIFICATION_START });

  try {
    const response = await fetch("/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        query: `query GetDocuPassByReference($input: DocuPassReferenceInput!) { 
          getDocuPassByReference(input: $input) { 
            status 
            message 
            error 
            code 
            reference 
            mode 
            profileId 
            decision 
            transactionId 
            customData 
            createdAt 
            completedAt 
            ip 
            url 
            finalTransaction { 
              id 
              decision 
              warning { 
                code 
                description 
                severity 
                confidence 
                decision 
              } 
            } 
          } 
        }`,
        variables: {
          input: {
            reference: reference,
          },
        },
      }),
    });

    const result = await response.json();
    const verificationData = result.data?.getDocuPassByReference;

    // Log for debugging
    console.log("Verification Response:", verificationData);

    // Handle the response with all possible fields
    if (verificationData) {
      if (verificationData.status === "success") {
        dispatch({
          type: CHECK_VERIFICATION_SUCCESS,
          payload: {
            status: verificationData.status,
            reference: verificationData.reference,
            mode: verificationData.mode,
            profileId: verificationData.profileId,
            decision: verificationData.decision,
            transactionId: verificationData.transactionId,
            customData: verificationData.customData,
            createdAt: verificationData.createdAt,
            completedAt: verificationData.completedAt,
            ip: verificationData.ip,
            url: verificationData.url,
            finalTransaction: verificationData.finalTransaction,
          },
        });

        // Return based on decision value
        if (verificationData.decision === "accept") {
          return "accept";
        } else if (verificationData.decision === "reject") {
          return "reject";
        } else {
          return null; // Return null for empty/pending decision
        }
      } else if (verificationData.status === "error") {
        dispatch({
          type: CHECK_VERIFICATION_ERROR,
          payload: {
            error: verificationData.error || "Verification failed",
            code: verificationData.code,
            message: verificationData.message,
          },
        });
        return "reject";
      }
    }

    return null; // Still pending
  } catch (error) {
    console.error("Verification Error:", error);
    dispatch({
      type: CHECK_VERIFICATION_ERROR,
      payload: {
        error: "Failed to check verification status",
      },
    });
    return null;
  }
};
